{
  "instances": {
    "logfile": {
      "label": "Fichier de log",
      "download": "Téléchargement",
      "wrap_lines": "Retour à la ligne",
      "page_up": "Page vers le haut",
      "page_down": "Page vers le bas",
      "previous_chunk": "Segment précédent",
      "next_chunk": "Segment suivant",
      "resume_follow": "Reprendre le suivi",
      "stop_follow": "Arrêter le suivi",
      "reconnecting": "Reconnexion...",
      "compressed_reset": "Fichier journal compressé, réinitialisation de la page"
    }
  }
}
